import React from 'react';
import { SearchDetails } from '../components/SearchDetails';
import { useAppContext } from '../context/AppContext';
import { useOfficeApi } from '../hooks/useOfficeApi';
import ErrorNotification from '../components/ErrorNotification';
import { Loading } from '@op/opds.opux';
import { useSearchParams } from 'react-router-dom';

export const SearchDetailsView = () => {
  const {
    loading,
    error,
    setLoading,
    setError,
    setOfficeDetails,
    officeDetails
  } = useAppContext();

  const officeApi = useOfficeApi({ setOfficeDetails });
  const [searchParams, setSearchParams] = useSearchParams();

  const konttorinro = searchParams.get('konttorinro');
  const konttorioyno = searchParams.get('konttorioyno');

  React.useEffect(() => {
    if (!konttorinro || !konttorioyno) {
      return;
    }

    const alreadyLoaded =
      !!officeDetails &&
      officeDetails.branchNumber === konttorinro &&
      officeDetails.companyId === konttorioyno;

    if (alreadyLoaded) {
      return;
    }

    let cancelled = false;
    setLoading(true);

    const fetchData = async () => {
      if (!cancelled) {
        await officeApi.fetchOfficeDetails(konttorinro, konttorioyno);
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [
    konttorinro,
    konttorioyno,
    officeDetails?.branchNumber,
    officeDetails?.companyId
  ]);

  const handleOfficeChange = async (
    branchNumber: string,
    companyId: string
  ) => {
    setError(null);

    const currentQuery = searchParams.get('query') ?? '';
    setSearchParams({
      query: currentQuery,
      konttorinro: branchNumber,
      konttorioyno: companyId
    });
  };

  return (
    <>
      {loading && <Loading data-testid="loader" className="loader-style" />}
      {error && <ErrorNotification message={error} />}
      {officeDetails && Object.keys(officeDetails).length > 0 && (
        <SearchDetails
          officeDetails={officeDetails}
          handleOfficeChange={handleOfficeChange}
        />
      )}
    </>
  );
};